import { printCustomerName } from 'components/CustomerAdmin/utils'
import {
    CustomerPaymentAccountDetailContract,
    CustomerLookupContract,
} from 'models'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { CustomerAccountPaymentModel } from './CustomerAccountsPaymentMobile'
interface IProps {
    selectedCustomerId?: string
    customerList: CustomerLookupContract[]
    paymentAccounts: CustomerPaymentAccountDetailContract[]
    onSelectCustomerAccount: (
        customerAccount: CustomerAccountPaymentModel,
    ) => void
    onCloseAccountDialog: () => void
}
export const useCustomerAccountPayment = ({
    selectedCustomerId,
    customerList,
    paymentAccounts,
    onSelectCustomerAccount,
    onCloseAccountDialog,
}: IProps) => {
    const customers = useMemo(() => {
        const clonedCustomerList = [...customerList]
        return clonedCustomerList.sort((a, b) => {
            const aName = printCustomerName(a)
            const bName = printCustomerName(b)

            return aName?.localeCompare(bName!!) ?? -1
        })
    }, [customerList])

    const [popupSelectCustomerId, setPopupSelectCustomerID] = useState(
        selectedCustomerId || '',
    )

    useEffect(() => {
        setPopupSelectCustomerID(selectedCustomerId || '')
    }, [selectedCustomerId])

    const customerPaymentAccounts = useMemo(() => {
        return paymentAccounts.flatMap((a) => a.customerPaymentAccounts ?? [])
    }, [paymentAccounts])

    const customerAccounts: CustomerAccountPaymentModel[] = useMemo(() => {
        return (
            customers
                ?.filter((c) =>
                    customerPaymentAccounts?.some(
                        (p) => p.customerID === c.customerID,
                    ),
                )
                ?.map((customer) => {
                    let account = paymentAccounts?.find((p) =>
                        p.customerPaymentAccounts?.some(
                            (c) => c.customerID === customer.customerID,
                        ),
                    )

                    return {
                        ...account,
                        customer,
                        isActive:
                            (account?.isActive ?? false) &&
                            customerPaymentAccounts.some(
                                (p) => p.customerID === customer.customerID,
                            ) &&
                            (customer.isActive ?? false),
                    }
                }) ?? []
        )
    }, [customerPaymentAccounts, customers, paymentAccounts])

    const selectedCustomer = useMemo(() => {
        return customerAccounts.find(
            (f) =>
                f.customer?.customerID === popupSelectCustomerId && f.isActive,
        )
    }, [customerAccounts, popupSelectCustomerId])

    const onAssignToPayment = useCallback(
        (customerID: string) => {
            const selectedCustomer = customerAccounts.find(
                (f) => f.customer?.customerID === customerID && f.isActive,
            )
            if (selectedCustomer) {
                onSelectCustomerAccount(selectedCustomer)
                onCloseAccountDialog()
                setPopupSelectCustomerID(customerID)
            }
        },
        [customerAccounts, onCloseAccountDialog, onSelectCustomerAccount],
    )
    return {
        onAssignToPayment,
        selectedCustomer,
        popupSelectCustomerId,
        setPopupSelectCustomerID,
        customerAccounts,
    }
}
